import type { IconProps } from '../types/IconProps.ts';
export const Grid2x2: IconProps = {
    name: 'Grid2x2',
    children: [
        `<rect width="18" height="18" x="3" y="3" rx="1" />`,
        `<path d="M3 12h18M12 3v18" />`,
    ]
};